import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { db, storage } from '../firebase';
import { addDoc, collection } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';

export default function Diagnosis() {
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  function handleDrop(e) {
    e.preventDefault();
    const f = e.dataTransfer.files[0];
    if (f) {
      setFile(f);
      setPreview(URL.createObjectURL(f));
    }
  }
  function handleFile(e) {
    const f = e.target.files[0];
    if (f) {
      setFile(f);
      setPreview(URL.createObjectURL(f));
    }
  }
  async function handleSubmit(e) {
    e.preventDefault();
    if (!file) {
      setError('請上傳至少一張照片');
      return;
    }
    setError('');
    setSuccess(false);
    setLoading(true);
    try {
      // 1. 上傳照片到 Storage
      const storageRef = ref(storage, `diagnosis_photos/${Date.now()}_${file.name}`);
      await uploadBytes(storageRef, file);
      const photoURL = await getDownloadURL(storageRef);
      // 2. 寫入 Firestore
      await addDoc(collection(db, 'diagnosis'), {
        name,
        email,
        message,
        photoURL,
        createdAt: new Date().toISOString()
      });
      setSuccess(true);
      setName('');
      setEmail('');
      setMessage('');
      setFile(null);
      setPreview(null);
    } catch (err) {
      setError('送出失敗，請稍後再試');
    }
    setLoading(false);
  }
  return (
    <div style={{ minHeight: '100vh', background: '#99C221', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start', paddingTop: 48 }}>
      <div style={{ display: 'flex', gap: 24, alignItems: 'center', marginBottom: 16, marginTop: -24 }}>
        <Link to="/main" style={{ color: '#2b9aff', fontWeight: 700, fontSize: 20, textDecoration: 'none' }}>無黴行動</Link>
        <Link to="/survey" style={{ color: '#2b9aff', fontWeight: 700, fontSize: 18, textDecoration: 'underline' }}>填寫問卷</Link>
      </div>
      <div style={{ background: '#fff', borderRadius: 16, boxShadow: '0 2px 16px #0001', padding: 32, maxWidth: 420, width: '95%', margin: '0 auto' }}>
        <h2 style={{ textAlign: 'center', fontWeight: 700, fontSize: '2rem', marginBottom: 8 }}>線上黴菌診斷</h2>
        <div style={{ textAlign: 'center', color: '#444', marginBottom: 24 }}>上傳照片或問題後可獲得初步專業分析回應</div>
        <form onSubmit={handleSubmit}>
          <div
            onDrop={handleDrop}
            onDragOver={e => e.preventDefault()}
            style={{ border: '2px dashed #2b9aff', borderRadius: 12, background: '#f8fbff', padding: 32, textAlign: 'center', marginBottom: 20, cursor: 'pointer' }}
            onClick={() => document.getElementById('fileInput').click()}
          >
            {preview ? (
              <img src={preview} alt="預覽" style={{ maxWidth: 180, maxHeight: 180, marginBottom: 8, borderRadius: 8 }} />
            ) : (
              <div style={{ color: '#888', fontSize: 18 }}>拖拉照片到這裡，或點擊上傳</div>
            )}
            <input id="fileInput" type="file" accept="image/*" style={{ display: 'none' }} onChange={handleFile} />
          </div>
          <input type="text" placeholder="姓名 or 暱稱" value={name} onChange={e => setName(e.target.value)} style={{ width: '100%', marginBottom: 12, padding: 10, borderRadius: 8, border: '1px solid #ddd', fontSize: 16 }} />
          <input type="email" placeholder="Email" value={email} onChange={e => setEmail(e.target.value)} style={{ width: '100%', marginBottom: 12, padding: 10, borderRadius: 8, border: '1px solid #ddd', fontSize: 16 }} />
          <textarea placeholder="留言 (非必填)" value={message} onChange={e => setMessage(e.target.value)} style={{ width: '100%', marginBottom: 16, padding: 10, borderRadius: 8, border: '1px solid #ddd', fontSize: 16, minHeight: 70 }} />
          {error && <div style={{ color: '#ff2e2e', marginBottom: 12 }}>{error}</div>}
          {success && <div style={{ color: '#2b9aff', marginBottom: 12 }}>已送出！我們會盡快回覆您</div>}
          <button type="submit" disabled={loading || success} style={{ width: '100%', background: loading ? '#bbb' : 'rgba(154, 71, 61, 0.97)', color: '#fff', fontWeight: 600, fontSize: 20, padding: '12px 0', border: 'none', borderRadius: 8, cursor: loading || success ? 'not-allowed' : 'pointer', marginTop: 4 }}>
            {loading ? '送出中...' : '送出'}
          </button>
        </form>
      </div>
    </div>
  );
}
